import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sidenav-buadmin',
  templateUrl: './sidenav-buadmin.component.html',
  styleUrls: ['./sidenav-buadmin.component.scss'],
  standalone: false
})
export class SidenavBuadminComponent {
  @Output() itemClick = new EventEmitter();

  public onItemClick = () => {
    this.itemClick.emit();
  }
}
